<template>
  <div class="app-container">
    <el-tabs v-model="tabName" type="card" @tab-click="handleClick">
      <el-tab-pane label="待入库工单" name="toPro">
        <to-pro-list ref="toProList" @tabChange="tabChange($event, '0')">
          
        </to-pro-list>
      </el-tab-pane>
      <el-tab-pane label="入库记录" name="proLog">
        <pro-log-list ref="proLogList" @tabChange="tabChange($event, '1')">
          <template slot="column">
            <el-table-column label="操作" fixed="right" align="center" width="160">
              <template slot-scope="{ row }">
                <el-button v-if="$permission.canWrite()" type="text" @click="undo(row)">撤销</el-button>
              </template>
            </el-table-column>
          </template>
        </pro-log-list>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import curdMixins from '@/mixins/trend/curd'
import toProList from '@/components/production/reportmanagement/prewarehousing/toPro/list'
import proLogList from '@/components/production/reportmanagement/prewarehousing/proLog/list'

export default {
  name: 'prewarehousing',
  mixins: [curdMixins],
  components: {
    toProList,
    proLogList,
  
  },
  data() {
    return {
      tabName: 'toPro',
      displayMode0: 1,
      displayMode1: 1,
      api: require('@/api/pu/report').default
    }
  },
  methods: {
    undo(row) {
      var loading = this.$loading({
        lock: true,
        text: '正在查询...',
        spinner: 'el-icon-loading',
        customClass: 'my_loading',
        background: 'rgba(0, 0, 0, 0.3)'
      })
      this.api
        .cancelPacking({ workDocId: row.WorkDocId})
        .then(res => {
          loading.close()
          if (res.Code === 0) {
            this.$refs.proLogList.reload()
            this.$message.success(res.Msg)
          } else {
            this.$message.error(res.Msg)
          }
        })
        .catch(err => {
          loading.close()
        })
    },
    // edit(row) {
    //   this.$refs.toProList.edit(row);
    // },
    openEdit() {
      const checkList = this.$refs.toProList.checkList
      if (checkList.length > 0) {
        this.edit({ checkList: checkList, batch: true })
      } else {
        this.$message.error('请勾选列表中的数据！')
      }
    },
    details(id) {
      this.$refs.proLogList.details(id)
    },
    handleClick() {
      this.reload()
    },
    reload() {
      this.$refs[this.tabName + 'List'].reload()
      this.$nextTick(() => {
        this.$refs[this.tabName + 'List'].$refs.list.$refs.table.doLayout()
      })
    },
    openDialog() {
      // this.$refs.alreadyReportDialog.open()
      const checkList = this.$refs.proLogList.checkList
      if (checkList.length == 1) {
        //this.$refs.alreadyReportDialog.openEdit({ checkList: checkList })
      } else {
        this.$message.error('请勾选列表中的一条数据！')
      }
    },
    tabChange(val, type) {
      if (val == '0') this['displayMode' + type] = 1
      if (val == '1') this['displayMode' + type] = 2
      if (val == '2') this['displayMode' + type] = 2
      if (val == '3') this['displayMode' + type] = 2
      if (val == '4') this['displayMode' + type] = 2
    }
  }
}
</script>